export default {"src":"/_next/static/media/about22.fd59090e.svg","height":226,"width":261};